import { cx } from "classix"
import type { ComponentProps, ElementType, ReactElement, RefObject } from "react"
import { Panel, type PanelProps } from "~/shared/ui/kit/components/Panel"
import { InfoList, type InfoListProps } from "~/shared/ui/kit/components/InfoList"


export type InfoPanelProps<C extends ElementType> = PanelProps & {
	itemsContainerElementType?: C
	itemsContainerProps?: ComponentProps<C>
	rootRef?: RefObject<HTMLDivElement>
} & InfoListProps & ComponentProps<"div">

export type InfoPanelComponent = (<C extends ElementType = "button">(props: InfoPanelProps<C>) => ReactElement) & {
	displayName: string
}

/**
 * Используется для отображения информации в виде списка элементов вида "подпись-контент".
 * Можно использовать как карточку с заголовком вверху и кнопками внизу. Основан на [Panel](/docs/shared-ui-kit-panel).
 */
export const InfoPanel = (function InfoPanel<C extends ElementType = "div">({
																				items,
																				itemsContainerElementType,
																				itemsContainerProps,
																				itemStyle,
																				itemLabelStyle,
																				itemContentStyle,
																				itemClassName,
																				itemLabelClassName,
																				itemContentClassName,
																				itemWrap,
																				itemsClassName,
																				itemsStyle,
																				rootRef,
																				...props
																			}: InfoPanelProps<C>) {

	const ItemsContainer = itemsContainerElementType ?? "div"

	return <Panel rootRef={rootRef} {...props}>
		{items && <ItemsContainer {...itemsContainerProps} className={cx(itemsContainerProps?.className)}>
			<InfoList itemWrap={itemWrap} items={items} itemStyle={itemStyle} itemLabelStyle={itemLabelStyle}
					  itemContentStyle={itemContentStyle} itemClassName={itemClassName}
					  itemLabelClassName={itemLabelClassName} itemContentClassName={itemContentClassName}
					  itemsClassName={itemsClassName} itemsStyle={itemsStyle} />
		</ItemsContainer>}
	</Panel>
}) as InfoPanelComponent